import getNavigationJSON from './ProcessJson';
import { isWebviewAndroid, isWebviewIOS } from './controlDevices';

function navigateParams(
    type: string,
    url: string,
    queryParams: any,
    storage?: any,
    title?: any,
    id?: any,
    host = true,
) {
    const jsonNav = getNavigationJSON(type, url, queryParams, title, id, host);
    const dataStorage = JSON.stringify(storage);
    // localStorage.setItem('storage', dataStorage);

    if (isWebviewAndroid) {
        window.Android?.getFromAndroid(jsonNav);
    } else if (isWebviewIOS) {
        window.webkit?.messageHandlers.jsMessageHandler.postMessage(jsonNav);
    } else {
        window.postMessage(dataStorage);
        return true;
    }

    return false;
}

export default navigateParams;
